// extracted by mini-css-extract-plugin
module.exports = {"btnContainer":"GenericTable_btnContainer__1p5GT","smallButton":"GenericTable_smallButton__1DKqN","dropdownList":"GenericTable_dropdownList__2cPD3"};